<template> 
  <v-card v-if="params.startNeedsInput" width="375" flat class="details-sdd mx-auto">
    <back-button v-if="!singlePaymentMethod" @click="$emit('abort')" :disabled="loader"/>
    
    <div>
      <v-form ref="form" v-model="formValid" @submit.prevent="">
        <div class="pageTitle">{{$t('online_wire_transfer')}}</div>
        <input-field 
          v-model="iban"
          :label="$t('iban_account')"
          :rules ='ibanRules'
          :placeHolder="$t('placeholder_iban')"
          :prependIcon="'$accountbalance'"
          v-mask="'AANN NNNN NNNN NNNN NNNN NNNN NNNN NNNN NNNN NNNN'"
          @errorupdate="onIbanErrorUpdate"
          :isLoading="loadingDisplayOptions"/>
      </v-form>
    </div>

    <v-card-actions class="pa-0 my-10">
      <ConfirmButton
        :disabled="!canConfirm"
        :isLoading="loader"
        @click="confirm"
        class="icon-button">
        <div class="d-flex">
          {{$t('continue')}}
            <img class="button-icon" src="@/assets/arrow-forward-outline.svg"/>
        </div>
      </ConfirmButton>
    </v-card-actions>

    <div class="footer">
      <img src="@/assets/lock-closed-outline-dark.svg"/>
      <div>{{$t('Transaction sécurisée par ')}}</div>
      <img src="@/assets/logo_ca_agorapay.png"/>
    </div>
  </v-card>
</template>

<script>
  import { VCard, VCardActions, VForm } from 'vuetify/lib'
  import ConfirmButton from '@/components/ConfirmButton'
  import BackButton from '@/components/BackButton'
  import validationRules from '../../../mixins/validationRules'
  import valueMappings from '@/mixins/valueMappings'
  import RequestHandler from '@/views/payment/mixins'
  import InputField from '@/components/InputField.vue'
  import testData from '../testData'
  import {mapState} from 'vuex'

  export default {
    name: 'PaymentDetailPISP',
    mixins: [validationRules, RequestHandler, valueMappings],
    components: { VCard, VCardActions, VForm, BackButton, ConfirmButton, InputField},
    props: {
      params: {
        type: Object,
        default: () => ({})
      }
    },
    created: function () {
      if (!this.params.startNeedsInput) this.$emit('confirm', {})
    },
    methods: {
      confirm: function () {
        this.loader = true
        setTimeout(() => {
          let data = { 
            iban: this.iban.replace(/\s/g, ''),
            bic: this.bic,
            registerAlias: this.params.registerAlias
          }
          this.$emit('confirm', data)
        }, 1000)
      },
      onIbanErrorUpdate: function (error) {
        this.ibanValid = !error
      },
      getDisplayOptions: function (iban) {
        if (this.loadingDisplayOptions) {
          this.repeatDemand = true
          return
        }

        let unformatted = iban.replace(/\s+/g, '')
        if (this.lastCheckedIban === unformatted) return
        this.lastCheckedIban = unformatted

        this.loadingDisplayOptions = true
        this.callSDDDisplayOptions({
          iban: this.iban.replace(/\s/g, ''),
          paymentMethodTypeId: this.params.methodTypeId,
          paymentMethodId: this.params.methodId
        }).then(rep => {
          if (process.env.NODE_ENV !== 'production') {
            setTimeout(() => {
              this.testcount++
              let mockData = this.testcount % 3 === 0 ? testData.displayOptions : testData.displayOptions
              this.ibanUnknown = mockData.statusCode
              this.bic = mockData.bic
              this.loadingDisplayOptions = false
            }, 2000)
          }
          else {
            if (!rep) throw new Error(this.$t('error_displayoptions'))
            const content = rep.content
            this.ibanUnknown = content.statusCode
            if (content.statusCode === '0') {
              this.bic = content.bic
            }
            else {
              this.bic = ''
            }
            this.loadingDisplayOptions = false
          }

          if (this.repeatDemand) {
            this.repeatDemand = false
            this.getDisplayOptions(this.iban)            
          }
        })
      }
    },
    computed: {
      ...mapState(['singlePaymentMethod']),
      ibanSepa: function () {
        return (this.iban.length > 1) ? this.isSepaIban(this.iban.slice(0,2)) : true
      },
      ibanRules: function () {
        let rules = [...this.rules.iban, 
          () => this.ibanSepa || this.$t('validation_iban_5')
        ]
        if (this.ibanUnknown !== '0') {
          rules.push(() => this.ibanUnknown === '7' ? this.$t('validation_iban_4') : this.$t('validation_iban_3'))
        }
        return rules
      },
      canConfirm: function () {
        return this.formValid && !this.loadingDisplayOptions
      }
    },
    watch: {
      iban: {
        handler: function (newValue) {
          this.ibanUnknown = '0'
          this.lastCheckedIban = ''
          setTimeout(() => { // wait until ibanValid is true
            if (newValue && this.ibanValid) this.getDisplayOptions(newValue)
          }, 200)
        }
      },
      ibanValid: {
        handler: function (newValue) {
          setTimeout(() => {
            if (newValue && this.iban) this.getDisplayOptions(this.iban)
          }, 200)
        }
      }
    },
    data: function () {
      return {
        formValid: false,
        iban: '',
        ibanValid: false,
        ibanUnknown: '0',
        bic: '',
        loader: false,
        testcount: 0,
        loadingDisplayOptions:false,
        repeatDemand: false,
        lastCheckedIban: ''
      }
    }
  }
</script>